// extracted by mini-css-extract-plugin
export var skipLink = "SkipToContent-module--skipLink--a1800";